import { render, staticRenderFns } from "./DocumentosConteoCreator.vue?vue&type=template&id=2bc3de3c&scoped=true"
import script from "./DocumentosConteoCreator.vue?vue&type=script&lang=js"
export * from "./DocumentosConteoCreator.vue?vue&type=script&lang=js"
import style0 from "./DocumentosConteoCreator.vue?vue&type=style&index=0&id=2bc3de3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3de3c",
  null
  
)

export default component.exports